import React, { useState, useEffect } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { getBusinesses } from "../Api/GmsBusiness";
import { getBranches } from "../Api/GmsBranch";
import { ClipLoader } from "react-spinners";
import API_URL from "../../config";
import "./CompanyBranchModal.css";

const CompanyBranchModal = ({ isOpen, isAdmin, onSelectionComplete, onCancel }) => {
  const [step, setStep] = useState(1); // 1: Company Selection, 2: Branch Selection
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  useEffect(() => {
    if (isOpen) {
      loadCompanies();
    }
  }, [isOpen]);

  const loadCompanies = async () => {
    setLoading(true);
    try {
      const response = await getBusinesses({ business_Active: true });
      const data = response.data || response;
      setCompanies(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error loading companies:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadBranches = async (companyId) => {
    setLoading(true);
    try {
      const response = await getBranches({ branch_Buisness_Id: companyId, branch_Active: true });
      const data = response.data || response;
      setBranches(Array.isArray(data) ? data : []);
      setStep(2);
    } catch (error) {
      console.error("Error loading branches:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCompanySelect = (company) => {
    setSelectedCompany(company);
    loadBranches(company.business_Id);
  };

  const handleBranchSelect = (branch) => {
    onSelectionComplete(selectedCompany, branch);
  };

  const handleBack = () => {
    setStep(1);
    setBranches([]);
  };

  return (
    <Modal
      isOpen={isOpen}
      centered
      backdrop={isAdmin ? true : "static"}
      keyboard={isAdmin}
      className="company-branch-modal"
      modalClassName="selection-modal-wrapper"
      style={{ maxWidth: '600px', width: '90%' }}
    >
      <div className="modal-header d-flex justify-content-between align-items-center">
        <h4 className="modal-title-custom mb-0">
          {step === 1 ? "Select Company" : "Select Branch"}
        </h4>
        {isAdmin && (
          <button className="close-btn-custom" onClick={onCancel} aria-label="Close">
            <i className="bx bx-x fs-4"></i>
          </button>
        )}
      </div>

      <ModalBody className="modal-body-premium">
        {loading ? (
          <div className="text-center py-5">
            <ClipLoader color="#556ee6" size={50} />
            <p className="mt-3 text-muted fw-semi-bold">Fetching available options...</p>
          </div>
        ) : (
          <>
            {step === 1 ? (
              <div className="selection-grid">
                {companies.map((company, index) => (
                  <div
                    key={company.business_Id}
                    className="selection-item-animated"
                  >
                    <div
                      className="selection-card"
                      onClick={() => handleCompanySelect(company)}
                    >
                      <div className="logo-container-premium">
                        {company.business_LogoPath ? (
                          <img
                            src={`${API_URL}${company.business_LogoPath}`}
                            alt={company.business_NameEn}
                          />
                        ) : (
                          <div className="placeholder-icon-premium icon-bg-glass">
                            <i className="bx bx-building"></i>
                          </div>
                        )}
                      </div>
                      <div className="selection-info-premium">
                        <h6 className="mb-1">{company.business_NameEn}</h6>
                        <p className="sub-text mb-0">{company.business_Code}</p>
                      </div>
                    </div>
                  </div>
                ))}
                {companies.length === 0 && (
                  <div className="w-100 text-center py-4 bg-light rounded-4">
                    <p className="text-muted mb-0">No companies available at this time.</p>
                  </div>
                )}
              </div>
            ) : (
              <div>
                <div className="d-flex align-items-center mb-4 ps-1">
                  <button
                    className="btn btn-back-premium"
                    onClick={handleBack}
                  >
                    <i className="bx bx-arrow-back me-2"></i> Back
                  </button>
                  <div className="ms-auto pe-1">
                    <span className="text-muted small fw-bold text-uppercase letter-spacing-1">
                      Company: <strong className="text-primary ms-1">{selectedCompany?.business_NameEn}</strong>
                    </span>
                  </div>
                </div>
                <div className="selection-grid">
                  {branches.map((branch, index) => (
                    <div
                      key={branch.branch_Id}
                      className="selection-item-animated"
                    >
                      <div
                        className="selection-card"
                        onClick={() => handleBranchSelect(branch)}
                      >
                        <div className="logo-container-premium">
                          <div className="placeholder-icon-premium icon-bg-glass" style={{ color: '#34d399' }}>
                            <i className="bx bx-store-alt"></i>
                          </div>
                        </div>
                        <div className="selection-info-premium">
                          <h6 className="mb-1">{branch.branch_NameEn}</h6>
                          <p className="sub-text mb-0">{branch.branch_Code}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                  {branches.length === 0 && (
                    <div className="w-100 text-center py-4 bg-light rounded-4">
                      <p className="text-muted mb-0">No branches found for this company.</p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default CompanyBranchModal;
